import { render, staticRenderFns } from "./SuperAdminTable.vue?vue&type=template&id=b8b772d8&"
import script from "./SuperAdminTable.vue?vue&type=script&lang=js&"
export * from "./SuperAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports